// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import keys from '../keys';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: keys.REACT_APP_FIREBASE_API_KEY,
  authDomain: "fremodel-2f29d.firebaseapp.com",
  projectId: "fremodel-2f29d",
  storageBucket: "fremodel-2f29d.firebasestorage.app",
  messagingSenderId: "40980622951",
  appId: "1:40980622951:web:88e8d63ee08f2f4a14eec2",
  measurementId: "G-4MBY4E1DQN"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
export const provider = new GoogleAuthProvider();
export const analytics = getAnalytics(app);
export const auth = getAuth(app);
export default db;